import { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Paths from "@/components/landing/Paths";
import Categories from "@/components/landing/Categories";
import HowItWorks from "@/components/landing/HowItWorks";
import Areas from "@/components/landing/Areas";
import CTA from "@/components/landing/CTA";
import Footer from "@/components/landing/Footer";
import Seo from "@/components/Seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Home() {
  const [categories, setCategories] = useState([]);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    axios.get(`${API}/categories`).then((r) => setCategories(r.data)).catch(() => {});
    axios.get(`${API}/locations`).then((r) => setLocations(r.data)).catch(() => {});
  }, []);

  return (
    <main className="bg-white">
      <Seo
        title="Prime Pro Connect Services | Find Trusted Local Professionals in Alabama"
        description="Find trusted local professionals with Prime Pro Connect Services. Request quotes for tree service, roofing, plumbing, HVAC, landscaping, cleaning, remodeling and more in Huntsville and surrounding Alabama areas."
        path="/"
      />
      <Navbar />
      <Hero categories={categories} />
      <Marquee categories={categories} locations={locations} />
      <Paths />
      <Categories categories={categories} />
      <HowItWorks />
      <Areas locations={locations} />
      <CTA />
      <Footer categories={categories} locations={locations} />
    </main>
  );
}
